<div class="tw-relative tw-flex tw-justify-between tw-mx-4 tw-px-4 tw-py-[21.5px] tw-rounded-3 tw-bg-gradient-white-to-orange" (click)="onBannerClick()">
  <div class="tw-absolute tw-top-0 tw-right-0 tw-p-1 tw-rounded-full">
    <div class="tw-absolute tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-[12px] tw-right-[12px] tw-p-1 tw-rounded-full" (click)="closeBottomSheet($event)">
      <div class="tw-flex tw-items-center tw-justify-center tw-text-gray-400" style="font-size: 12px; line-height: 0.8; font-weight: 700!important;">&#10005;</div>
    </div>
  </div>
  <div>
    <p class="tw-font-lexend tw-text-400 tw-text-gray-900" i18n="@@nameYourDoctorCheckupsAreLocked">{{regimenExpiredBannerData?.firstName}}, your doctor <br/> check-ups are locked.</p>
    <p class="tw-font-normal tw-text-200 tw-mt-1 tw-text-gray-800" i18n="@@restartTreatmentToUnlock">Restart treatment to unlock.</p>
    <div slot="button" class="tw-w-max tw-mt-4 tw-bg-teal-600 tw-rounded-2 tw-text-300 tw-text-white tw-font-body tw-px-8 tw-py-[10px] tw-align-baseline xs:tw-px-6 xxxs:tw-px-4" style="font-weight: 700!important;">
      <div class i18n="@@restartTreatment">Restart Treatment</div>
    </div>
  </div>
  <div class=" tw-relative tw-w-20 tw-h-20">
    <div class="tw-w-7 tw-h-7 tw-absolute tw-top-0 -tw-left-2 tw-bg-orange-700 tw-rounded-full tw-flex tw-items-center tw-justify-center">
      <img src="/assets/icons/lock-icon-white.svg" class="tw-w-[12px] tw-h-[15px]" alt="lock-icon">
    </div>
    <img [src]="regimenExpiredBannerData?.image" class="tw-rounded-full tw-min-w-20 tw-min-h-20" alt="regimen-expired-banner">
  </div>
</div>
